import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { brandsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useDeleteBrand(options?: {
  silent?: boolean;
}): UseMutationResult<Response, unknown, number> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (brandId: number) =>
      apiClient.url(`/brands/${brandId}`).delete().res(),

    onError: (error: unknown) => {
      if (options?.silent) return;

      const errorMessage =
        (error as { message?: string })?.message || "Failed to delete brand";

      toast.add({
        description: errorMessage,
        timeout: 3000,
        title: "Delete failed",
        type: "error",
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: brandsKeys.all });

      if (options?.silent) return;

      toast.add({
        description: "Brand deleted successfully",
        timeout: 2000,
        title: "Success",
        type: "success",
      });
    },
  });
}
